const ReviewsBaseMixin = Base =>
  class ReviewsBase extends Base {
    constructor(loc) {
      super();
      this.loc = loc;
      this.setReviews(this.loc.data.reviews || []);
    }

    get overallRating() {
      let overallRatings = this.data.map(review => review.overallRating);
      let overallRating =
        overallRatings.reduce((a, r) => a + r, 0) / overallRatings.length;
      return !isNaN(overallRating) ? overallRating.toFixed(1) : '';
    }

    get summary() {
      let ratings = Array.from(
        this.data
          .flatMap(review => review.ratings)
          .reduce((map, rating) => {
            switch (rating.aggregation) {
              case 'last':
                {
                  let replaceRating =
                    !map.has(rating.id) ||
                    map.get(rating.id).date < rating.date;
                  if (replaceRating) {
                    map.set(rating.id, rating);
                  }
                }
                break;
            }
            return map;
          }, new Map())
          .values()
      );

      return this.loc.ratingInfo
        .map(group =>
          Object.assign({
            id: group.id,
            label: group.label,
            ratings: ratings.filter(rating => rating.group?.id == group.id),
          })
        )
        .filter(group => group.ratings.length > 0);
    }

    at(index) {
      return this.data[index];
    }

    setReviews(reviews) {
      this.data = reviews.map(reviewData => this.CreateItem(reviewData));
    }

    static get Review() {
      throw new Error(`[data] 'Review' must be overriden in a derived class`);
    }

    static Sort(a, b) {
      return new Date(b.date) - new Date(a.date);
    }

    static Is(a, b) {
      return a.id == b.id;
    }

    CreateItem(data) {
      return new this.constructor.Review(data, this.loc);
    }

    #ratings;
  };

export { ReviewsBaseMixin };
